import React, { useState } from "react";
import { useSubject } from "../context/SubjectContext";
import { useCenter } from "../context/CenterContext";
import VisitCard from "./VisitCard";
import { Link } from "react-router-dom";
import './VisitCards.css';
import { useModerationWindowSession } from "../constants/Constants";
import {getCenterType} from "../utils/utils";
import { useConsortiaCenter } from "../context/ConsortiaCenterContext";

const ICONS = {
  "Visit Requested":
    "M200-640h560v-80H200v80Zm0 0v-80 80Zm0 560q-33 0-56.5-23.5T120-160v-560q0-33 23.5-56.5T200-800h40v-80h80v80h320v-80h80v80h40q33 0 56.5 23.5T840-720v227q-19-9-39-15t-41-9v-43H200v400h252q7 22 16.5 42T491-80H200Zm520 40q-83 0-141.5-58.5T520-240q0-83 58.5-141.5T720-440q83 0 141.5 58.5T920-240q0 83-58.5 141.5T720-40Zm67-105 28-28-75-75v-112h-40v128l87 87Z",
  "Visit Confirmed":
    "M600-80v-80h160v-400H200v160h-80v-320q0-33 23.5-56.5T200-800h40v-80h80v80h320v-80h80v80h40q33 0 56.5 23.5T840-720v560q0 33-23.5 56.5T760-80H600ZM320 0l-56-56 103-104H40v-80h327L264-344l56-56 200 200L320 0ZM200-640h560v-80H200v80Zm0 0v-80 80Z",
  "Visit Cancelled": "m388-212-56-56 92-92-92-92 56-56 92 92 92-92 56 56-92 92 92 92-56 56-92-92-92 92ZM200-80q-33 0-56.5-23.5T120-160v-560q0-33 23.5-56.5T200-800h40v-80h80v80h320v-80h80v80h40q33 0 56.5 23.5T840-720v560q0 33-23.5 56.5T760-80H200Zm0-80h560v-400H200v400Zm0-480h560v-80H200v80Zm0 0v-80 80Z",
  "Visit Completed":
    "M438-226 296-368l58-58 84 84 168-168 58 58-226 226ZM200-80q-33 0-56.5-23.5T120-160v-560q0-33 23.5-56.5T200-800h40v-80h80v80h320v-80h80v80h40q33 0 56.5 23.5T840-720v560q0 33-23.5 56.5T760-80H200Zm0-80h560v-400H200v400Z",
};

const STATUS_COLORS = {
  "Visit Requested": "warning",
  "Visit Confirmed": "info",
  "Visit Cancelled": "cancel",
  "Visit Completed": "success",
};

export default function VisitCards() {
  const moderationWindowSession = useModerationWindowSession();
  const { subjectData } = useSubject();
  const [open, setOpen] = useState({});
  const { centerNumber } = useCenter();
    const { consortiaCentres =[] } = useConsortiaCenter();
  
  
          
  const subjectId = subjectData?.selectedSubjectId;
  const currentCentreType = getCenterType(consortiaCentres, Number(centerNumber), subjectData?.selectedSubject, subjectId) || '';
  const LOCAL_STORAGE_KEY = `moderationFormData_${centerNumber}_${subjectId}`;


  const toggle = (id) => () =>
    setOpen((prev) => ({ ...prev, [id]: !prev[id] }));

  const getSessionDetails = (visits) => {
    const academicYear = `${new Date(
      visits.sessionStartDate
    ).getFullYear()}/${String(
      new Date(visits.sessionEndDate).getFullYear()
    ).slice(-2)}`;
    return visits.sessionId === moderationWindowSession.window1
      ? `Window 1 (February series) - ${academicYear}`
      : `Window 2 (June series) - ${academicYear}`;
  };


  const onClickEditReq = (visits) => {
    let formData = {
      visitArrangementId: visits.visitArrangementId,
      updatedBy: '',
      isConsortium: visits.isConsortium.toLowerCase() === 'y' ? 'yes' : 'no',
      moderationWindow: visits.sessionId === moderationWindowSession.window1 ? 'window1' : 'window2',
      moderationType: visits.moderationType,
      selectedUnits: visits.assessments.map(val => val.split(':')[0]),
      preferredDates: visits.preferredDates,
      firstName: visits.primaryFirstName,
      lastName: visits.primaryLastName,
      email: visits.primaryEmailId,
      telephone: visits.primaryTelephoneNo,
      secondaryFirstName: visits.secondaryFirstName,
      secondaryLastName: visits.secondaryLastName,
      secondaryEmail: visits.secondaryEmailId,
      secondaryTelephone: visits.secondaryTelephoneNo,
      showSecondaryContact: visits.isSecondaryContact,
    }
    localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(formData));
  }

  const getRouteName = (subject) =>
    subject
      ?.toLowerCase()
      .replace(/[^a-z0-9]+/g, "_")
      .replace(/^_+/, "")   // strip leading underscores
      .replace(/_+$/, "");  // strip trailing underscores


  if (!subjectData?.subjectDetails?.visitArrangementResponse) {
    return <p>No visit arrangements available.</p>;
  }

  return (
    <div className="visit-cards-wrapper mt-5" >
      {subjectData.subjectDetails.visitArrangementResponse
        .filter((vis) => ["Visit Requested", "Visit Confirmed", "Visit Cancelled", "Visit Completed"].includes(vis.statusType))
        .map((visits) => {
          const visitId = visits.visitArrangementId;
          const assessments = visits.assessments
            .map((a) => a.split(":")[0])
            .join(", ");
          const fullAssessmentNames = visits.assessments;
          const tags = [
            { label: `Units: ${assessments}`, className: "" },
            { label: getSessionDetails(visits), className: "" },
            { label: visits.moderationType === 'Face-to-Face' ? 'Face-to-face' : visits.moderationType, className: "" },
          ];
          return (
            <VisitCard
              key={visitId}
              statusColor={STATUS_COLORS[visits.statusType] || "warning"}
              icon={ICONS[visits.statusType] || ICONS["Visit Requested"]}
              title={visits.statusType.charAt(0).toUpperCase() + visits.statusType.slice(1).toLowerCase()}
              tags={tags}
              expanded={!!open[visitId]}
              toggle={toggle(visitId)}
              visitDate={visits['visitDate']}
              additionalVisitDate={visits['additionalVisitDate']}
            >
              {visits.statusType === 'Visit Requested' &&
                <p className="visit-card-message">Your moderator will contact you to confirm details.</p>}

              <div className="columns is-multiline mt-3">
                <div className="column is-6">
                  <p className="visit-card-section-label">
                    {visits.statusType === 'Visit Completed' ? 'Units moderated:' : 'Units being moderated'}
                  </p>
                  <div style={{ marginTop: "-8px" }}>
                    {fullAssessmentNames.map((unit) => (
                      <div className="visit-card-unit" key={unit}>{unit.replace(":", " ")}</div>
                    ))}
                  </div>
                </div> {
                  visits?.statusType === 'Visit Requested' && <div className="column is-6">
                    <p className="visit-card-section-label">Preferred dates:</p>
                    <div style={{ marginTop: "-8px" }}>
                      {visits.preferredDates.map((date) => (
                        <div className="visit-card-date" key={date}>
                          Week beginning{" "}
                          {new Date(date).toLocaleDateString("en-GB", {
                            day: "2-digit",
                            month: "short",
                            year: "numeric",
                          })}
                        </div>
                      ))}
                    </div>
                  </div>
                }

              </div>
              {['Visit Confirmed', 'Visit Cancelled', 'Visit Completed'].includes(visits.statusType) &&
                <p className="visit-card-moderator">
                  <strong>Moderator:</strong>{" "}
                  <span>
                   {visits.moderatorName || "-"}
                  </span>
                </p>
              }
              <p className="visit-card-contact">
                <strong>Contact for this visit:</strong>{" "}
                <span>
                  {visits.primaryFirstName && visits.primaryLastName
                    ? `${visits.primaryFirstName} ${visits.primaryLastName}`
                    : "N/A"}
                </span>
              </p>
              {( ( ( currentCentreType === 'Rest' && visits.isConsortium !== 'Y' )&& visits?.statusType === 'Visit Requested')  ||
              (currentCentreType !== 'Rest' && visits?.statusType === 'Visit Requested')) &&
                <p className="mt-3 is-flex is-align-items-center">
                  <span className="icon is-small mr-2">
                    <svg

                      style={{
                        WebkitFontSmoothing: "antialiased",
                        textRendering: "optimizeLegibility",
                        textSizeAdjust: "100%",
                        fontVariantLigatures: "none",
                        fontFamily:
                          "'Open Sans', 'Source Sans 3', Arial, Helvetica, sans-serif",
                        fontStyle: "inherit",
                        fontWeight: "inherit",
                        height: "24px",
                        width: "24px",
                        boxSizing: "inherit",
                        fill: "#767676",
                        color: "#363636",
                      }}
                      xmlns="http://www.w3.org/2000/svg"
                      height="24px"
                      viewBox="0 -960 960 960"
                      width="24px"
                    >
                      <path d="M200-80q-33 0-56.5-23.5T120-160v-560q0-33 23.5-56.5T200-800h40v-80h80v80h320v-80h80v80h40q33 0 56.5 23.5T840-720v200h-80v-40H200v400h280v80H200Zm0-560h560v-80H200v80Zm0 0v-80 80ZM560-80v-123l221-220q9-9 20-13t22-4q12 0 23 4.5t20 13.5l37 37q8 9 12.5 20t4.5 22q0 11-4 22.5T903-300L683-80H560Zm300-263-37-37 37 37ZM620-140h38l121-122-18-19-19-18-122 121v38Zm141-141-19-18 37 37-18-19Z"></path>
                    </svg>
                  </span>

                  {subjectData?.selectedSubject && (
                    <Link
                      to={`/dashboard/visit_form/${getRouteName(subjectData.selectedSubject)}`}
                      className="is-link"
                      state={{ isEditRequest: true, existingUnits: fullAssessmentNames }}
                      onClick={() => onClickEditReq(visits)}
                    >
                      Edit this visit request
                    </Link>
                  )}
                </p>
              }
            </VisitCard>
          );
        })}
    </div>
  );
}

